import { render } from "./DataTableBackend.vue?vue&type=template&id=235da532&scoped=true"
import script from "./DataTableBackend.vue?vue&type=script&lang=js"
export * from "./DataTableBackend.vue?vue&type=script&lang=js"

import "./DataTableBackend.vue?vue&type=style&index=0&id=235da532&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235da532"]])

export default __exports__